import React, { useState, useEffect } from 'react';
import './InstallPrompt.css';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Détecter iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iOS);

    // Détecter si l'app est déjà installée (mode standalone)
    const standalone = window.matchMedia('(display-mode: standalone)').matches ||
                       window.navigator.standalone ||
                       document.referrer.includes('android-app://');
    setIsStandalone(standalone);

    // Vérifier si l'app est déjà installée
    if (standalone) {
      setIsInstalled(true);
      return;
    }

    // Écouter l'événement beforeinstallprompt (Android/Chrome)
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Afficher le prompt après 3 secondes
      setTimeout(() => {
        setShowPrompt(true);
      }, 3000);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Vérifier si l'app est installée (pour iOS, on vérifie le mode standalone)
    const checkInstalled = () => {
      if (standalone) {
        setIsInstalled(true);
      }
    };

    checkInstalled();

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    // Afficher le prompt d'installation
    deferredPrompt.prompt();

    // Attendre la réponse de l'utilisateur
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      setIsInstalled(true);
      setShowPrompt(false);
    }

    // Réinitialiser le prompt
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    // Ne plus afficher pendant cette session
    sessionStorage.setItem('pwa-install-dismissed', 'true');
  };

  // Ne pas afficher si déjà installée ou si l'utilisateur a fermé le prompt
  if (isInstalled || isStandalone || !showPrompt || sessionStorage.getItem('pwa-install-dismissed')) {
    return null;
  }

  // Instructions pour iOS
  if (isIOS && !isStandalone) {
    return (
      <div className="install-prompt ios-prompt">
        <div className="install-prompt-content">
          <div className="install-prompt-icon">📱</div>
          <h3>Installer l'application</h3>
          <p>Pour installer cette application sur votre iPhone/iPad :</p>
          <ol>
            <li>Appuyez sur le bouton <strong>Partager</strong> <span className="share-icon">⎋</span></li>
            <li>Sélectionnez <strong>"Sur l'écran d'accueil"</strong></li>
            <li>Appuyez sur <strong>"Ajouter"</strong></li>
          </ol>
          <button className="install-dismiss-btn" onClick={handleDismiss}>
            Fermer
          </button>
        </div>
      </div>
    );
  }

  // Prompt pour Android/Chrome
  if (deferredPrompt && !isIOS) {
    return (
      <div className="install-prompt android-prompt">
        <div className="install-prompt-content">
          <div className="install-prompt-icon">📲</div>
          <h3>Installer l'application</h3>
          <p>Installez cette application pour un accès rapide et une meilleure expérience.</p>
          <div className="install-prompt-actions">
            <button className="install-btn" onClick={handleInstallClick}>
              Installer
            </button>
            <button className="install-dismiss-btn" onClick={handleDismiss}>
              Plus tard
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default InstallPrompt;

